import React from 'react';
import { useTenant } from '../../contexts/TenantContext';
import { privateRecipeUrl } from '../recipes/PrivateRecipeImage';
import { useImageUnique } from './imageUnique';

/* Règle générale : le logo du client sur tout ce qui s'imprime ; sans logo, son nom */
export const MarqueEtablissement = ({ hauteur = '9mm', nom: nomForce, testId = 'marque-etablissement' }) => {
  const { tenant } = useTenant();
  const logo = tenant?.branding?.logo_url || tenant?.logo_url;
  const src = useImageUnique(logo ? privateRecipeUrl(logo) : null);
  const nom = nomForce || tenant?.name || '';
  if (logo) return src ? <img className="marque-etab" src={src} data-logo="" alt={nom} style={{ height: hauteur }} data-testid={testId} /> : null;
  return nom ? <span className="marque-etab is-nom" data-testid={testId}>{nom}</span> : null;
};

/* Imprimé avec la page (window.print) : en haut à droite de chaque feuille */
export const MarqueImpression = () => <div className="marque-print" aria-hidden="true"><MarqueEtablissement testId="marque-impression" /></div>;
